import Layout from '~components/layout'
const routes = [{
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'home',
                meta: {
                    title: "首页"
                },
                component: () => import('~pages/home')
            },
            {
                path: 'admin',
                name: 'admin',
                meta: {
                    title: "管理后台",
                    requireAdmin: true
                },
                component: () => import('~pages/admin')
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        meta: { title: '登录' },
        component: () => import('~pages/login')
    }
]
export default routes;